// extracted by css-extract-rspack-plugin
export default {"container":"_5ea8f307","link":"_9e292c80","lastChild":"_fd65bd00"};